import { useContext, useEffect, useState, useRef, Dispatch } from 'react';
import DeleteIcon from '../../../../../../assets/images/svg/delete-icon.svg';
import { ProductListingContext } from '../../../../functions/data_formatting_functions';
import {
  actionSetAllAttributes,
  actionSetListingData,
} from '../../../../store/create_listing_actions';
import styled from 'styled-components';
import { BaseBooleanAttribute } from '../../../../../../data/types/attributes';
import { ListingState } from '../../../../../../data/types/listings';
import { Label } from '../../../../../../styles/style';

type BooleanAttributesProps = {
  attribute: BaseBooleanAttribute;
  productType: number;
};

export default function BooleanAttributes({
  attribute,
  productType,
}: BooleanAttributesProps) {
  const {
    state,
    dispatch,
  }: {
    state: ListingState;
    dispatch: Dispatch<any>;
  } = useContext(ProductListingContext);
  const [multiple, setMultiple] = useState(attribute.is_variable);
  const [bool_values, setBoolValues] = useState(attribute?.values || []);
  const [firstRun, setFirstRun] = useState(true);
  const initialRender = useRef(true);

  const onChange = () => {
    setMultiple(!multiple);
  };
  useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false;
    } else {
      if (multiple) {
        setBoolValues([true, false]);
      } else {
        // setBoolValues([bool_values[0]] || []);
        if (bool_values.length > 0) {
          setBoolValues([bool_values[0]]);
        } else {
          setBoolValues([]);
        }
      }
    }
  }, [multiple]);

  useEffect(() => {
    if (firstRun) {
      setFirstRun(false);
      return;
    }
    setMultiple(productType === 1 ? false : attribute.is_variable);
    setBoolValues([]);
    setIsVariableForAttribute(
      productType === 1 ? false : attribute.is_variable,
    );
  }, [productType]);

  const setIsVariableForAttribute = (multiple: boolean) => {
    state.data.boolean_attrs?.forEach((x: any, i: number) => {
      if (x.name_en === attribute.name_en) {
        if (multiple) {
          if (state.data.boolean_attrs[i].values.length != bool_values.length) {
            state.data.combinations_table = [];
          } else {
            if (
              bool_values.length === 1 &&
              bool_values[0] != state.data.boolean_attrs[i].values[0]
            ) {
              state.data.combinations_table = [];
            }
          }
        } else {
          state.data.combinations_table = [];
        }
        state.data.boolean_attrs[i].is_variable = multiple;
        state.data.boolean_attrs[i].values = bool_values;
        dispatch(
          actionSetListingData({
            ...state.data,
            boolean_attrs: [...state.data.boolean_attrs],
            combinations_table: [...state.data.combinations_table],
          }),
        );
      }
    });
    state.all_attributes?.forEach((x: any, i: number) => {
      if (x.name_en === attribute.name_en) {
        state.all_attributes[i].is_variable = multiple;
        if (state.all_attributes[i].values)
          state.all_attributes[i].values = bool_values;
        if (state.all_attributes[i].official_values)
          state.all_attributes[i].official_values = bool_values;
        dispatch(actionSetAllAttributes([...state.all_attributes]));
      }
    });
  };

  useEffect(() => {
    setIsVariableForAttribute(multiple);
  }, [bool_values]);

  const remove = () => {
    dispatch(
      actionSetAllAttributes(
        state.all_attributes?.filter(
          (attr) => attr.name_en != attribute.name_en,
        ),
      ),
    );
    dispatch(
      actionSetListingData({
        ...state.data,
        combinations_table: [],
        boolean_attrs: state.data.boolean_attrs?.filter(
          (attr) =>
            attr.name_en != attribute.name_en ||
            attr.name_ar != attribute.name_ar,
        ),
      }),
    );
  };

  const setValues = (value: any) => {
    if (multiple) {
      if (!bool_values.includes(value)) {
        setBoolValues([...bool_values, value]);
      } else {
        setBoolValues([...bool_values.filter((val: any) => val !== value)]);
      }
    } else {
      setBoolValues([value]);
    }
  };

  return (
    <Wrapper>
      <div className="d-flex justify-content-between">
        <div className=" d-flex justify-content-around">
          <Label
            color="#00273380"
            style={{
              fontSize: '15px',
            }}
          >
            {attribute.name_en}
            {` `}
            {attribute.name_ar !== undefined ? `-${attribute.name_ar}` : ``}
          </Label>
          <>
            <div // <Icon
              className="form-check"
              style={{
                display: 'flex',
                alignItems: 'center',
                marginLeft: '20px',
              }}
            >
              <input
                className="form-check-input"
                type="radio"
                name={`boolean${attribute.name_en}true`}
                id={`boolean${attribute.name_en}true`}
                onClick={() => setValues(true)}
                checked={bool_values.includes(true)}
                onChange={() => {}}
              />
              <label className="form-check-label" htmlFor="flexRadioDefault1">
                Yes
              </label>
            </div>
            <div // <Icon
              className="form-check used"
              style={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <input
                className="form-check-input"
                type="radio"
                name={`boolean${attribute.name_en}false`}
                id={`boolean${attribute.name_en}false`}
                onClick={() => setValues(false)}
                checked={bool_values.includes(false)}
                onChange={() => {}}
              />
              <label className="form-check-label" htmlFor="flexRadioDefault2">
                No
              </label>
            </div>
          </>
        </div>
        <div // <Icon
          className={`position-relative info-hover attributes-icons flex ${
            attribute.custom && productType === 1
              ? 'justify-content-between'
              : 'justify-content-end'
          }`}
        >
          {attribute.custom && (
            <img
              src={DeleteIcon}
              alt="delete_icon"
              className="cursor-pointer"
              onClick={remove}
            />
          )}
          {productType === 1 && (
            <div className="checkBoxes flex">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name={`multiple${attribute.name_en}`}
                  id={`multiple${attribute.name_en}`}
                  checked={multiple}
                  onClick={onChange}
                  onChange={() => {}}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </Wrapper>
  );
}
const Wrapper = styled.div`
  .flex {
    display: flex;
    align-items: center;
  }
  .justify-content-between {
    /* display: flex; */
    justify-content: space-between;
  }
  .justify-content-end {
    /* display: flex; */
    justify-items: flex-end;
  }

  .position-relative {
    position: relative;
  }
`;
